import { Button, Stack, Typography } from "@mui/material";
import { useState } from "react";

export const ExpandedTextBlock = ({
  text,
  maxLength = 130,
}: {
  text: string;
  maxLength?: number;
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  return (
    <Stack>
      <Typography
        variant="subtitle1"
        color="text.secondary"
        sx={{
          overflowWrap: "break-word",
        }}
      >
        {!isExpanded && text.length > maxLength
          ? `${text.substring(0, maxLength)} ...`
          : text}
      </Typography>

      {text.length > maxLength && (
        <Button
          variant="text"
          sx={{
            maxWidth: "fit-content",
            color: "#1C3C6C",
            "&:hover": {
              backgroundColor: "#F1F1F1",
            },
          }}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? "Show Less" : "Read More"}
        </Button>
      )}
    </Stack>
  );
};
